module.exports = __webpack_public_path__ + "media/Lord Slayer - Marcus’ Theme.e5fb5cc4.mp3";